import React, { useState } from 'react'
import { View } from 'styles/reactnative'

import { SearchOutlined } from '@ant-design/icons'
import {
	Button,
	DatePicker,
	Input,
	message,
	Popover,
	Radio,
	Select,
	Space,
} from 'antd'
import TableAPI from '../../../components/TableAPI'
import { AdminDepositTableColumn } from './AdminDepositTableColumn'

import { IconInfoSquare } from '@tabler/icons'
import SettingGroup from 'app/adminpages/AdminSystem/SettingGroup'
import { useToken } from 'app/hooks'
import dayjs from 'dayjs'
import API from 'utils/api'
import { useUserGroup } from '../../../hooks/user/usergroups'
import { useUserList } from '../../../hooks/user/userlist'

const AdminDepositManagement = ({ title, type }: any) => {
	const params = new URLSearchParams(window.location.search)
	const idquery = params.get('userid')
	const process = params.get('process')

	const { data: token } = useToken()

	const [user_id, setUser_id] = useState<any>(idquery || '')
	const [status, setStatus] = useState<any>(process || '')
	const [startDate, setStartDate] = useState<any>(null)
	const [endDate, setEndDate] = useState<any>(null)
	const [search, setSearch] = useState<any>('')

	const [tempid, setTempid] = useState<any>(idquery || '')
	const [tempsearch, setTempsearch] = useState<any>('')

	const [group, setGroup] = useState<any>('*')
	const { type1 } = useUserGroup()

	const [DTYPE, setDTYPE] = useState<any>(process || '')

	const makeurl = (check, query) => {
		if (check) {
			return `&${query}=${check}`
		} else {
			return ''
		}
	}

	const { usertype1 } = useUserList()

	return (
		<View style={{ width: '100%' }}>
			{/*<AdminDepositTable type={type} />*/}
			<View
				style={{
					width: '100%',
					padding: 10,
					flexDirection: 'row',
					background: '#fff',
					marginTop: 5,
					marginBottom: 5,
					borderRadius: 10,
					flex: 1,
					justifyContent: 'space-between',
					alignItems: 'center',
				}}>
				<View
					style={{
						flexDirection: 'row',
						flex: 1,
						justifyContent: 'flex-start',
						alignItems: 'center',
					}}>
					<Radio.Group
						onChange={e => {
							setStatus(e.target.value)
						}}
						buttonStyle="solid"
						size="small"
						value={status}
						style={{ marginRight: 10 }}>
						<Radio.Button value={''}>전체</Radio.Button>
						<Radio.Button value={'1'}>입금신청</Radio.Button>
						<Radio.Button value={'3'}>입금대기</Radio.Button>
						<Radio.Button value={'4'}>거절</Radio.Button>
						<Radio.Button value={'2'}>입금완료</Radio.Button>
					</Radio.Group>
					<Select
						value={DTYPE}
						onChange={e => {
							setDTYPE(e)
						}}
						filterOption={true}
						options={[
							{ value: '', label: '전체보기' },
							{ value: '1', label: '현금입출금만' },
							{ value: '2', label: '별도입출금만' },
							{ value: '3', label: '해선<>코인' },
						]}
						style={{ marginRight: 10, minWidth: 200 }}
					/>

					<SettingGroup
						title={'그룹설정'}
						group={group}
						setGroup={setGroup}
						style={{ maxWidth: 200, borderBottom: 0 }}
						defaultv="*"
					/>
					<Space.Compact direction="horizontal">
						<Popover
							placement="bottom"
							trigger={'click'}
							content={
								<Space style={{ alignItems: 'center' }}>
									<Select
										style={{ width: '100%', minWidth: 200 }}
										defaultValue={''}
										onChange={e => {
											setUser_id(e)
										}}
										options={[
											{ value: '', label: '전체' },
											...(usertype1 || []),
										]}
									/>
								</Space>
							}>
							<Input
								placeholder="회원검색"
								value={tempid}
								onChange={e => {
									setTempid(e.target.value)
								}}
								onKeyDown={e => {
									if (e.key === 'Enter') {
										setUser_id(tempid)
									}
								}}
							/>
						</Popover>
						<Button
							onClick={() => {
								setUser_id(tempid)
							}}
							style={{ paddingTop: 0 }}
							size="small">
							<SearchOutlined />
						</Button>

						<Input
							placeholder="비고검색"
							value={tempsearch}
							onKeyDown={e => {
								if (e.key === 'Enter') {
									setSearch(tempsearch)
								}
							}}
							onChange={e => {
								setTempsearch(e.target.value)
							}}
						/>
						<Button
							onClick={() => {
								setSearch(tempsearch)
							}}
							style={{ paddingTop: 0 }}
							size="small">
							<SearchOutlined />
						</Button>
					</Space.Compact>
				</View>

				<Space>
					기간
					<Space.Compact>
						<DatePicker
							onChange={e =>
								setStartDate(
									dayjs(e, 'YYYY-MM-DD').format('YYYY-MM-DD')
								)
							}
							defaultValue={
								startDate
									? dayjs(startDate, 'YYYY-MM-DD')
									: undefined
							}
						/>
						<DatePicker
							onChange={e =>
								setEndDate(
									dayjs(e, 'YYYY-MM-DD').format('YYYY-MM-DD')
								)
							}
							defaultValue={
								endDate
									? dayjs(endDate, 'YYYY-MM-DD')
									: undefined
							}
						/>
					</Space.Compact>
					<Button
						onClick={() => {
							API.getBlob(
								`/admin/user/cash?group=${group}&dtype=${DTYPE}&type=*${makeurl(
									startDate,
									'startdate'
								)}${makeurl(endDate, 'enddate')}${makeurl(
									user_id,
									'userid'
								)}${makeurl(status, 'process')}&excel=1&t=`,
								token + '',
								{}
							)
								.then(async (res: any) => {
									const blob = await res.blob()
									var _url = window.URL.createObjectURL(blob)
									if (_url) {
										// 다운로드를 트리거하기 위한 링크 생성
										const link = document.createElement('a')
										link.href = _url
										link.download = '입출금현황.xlsx'
										document.body.appendChild(link)
										link.click()
										document.body.removeChild(link)
										window.URL.revokeObjectURL(_url) // 메모리 해제
									} else {
										message.error(
											'파일을 다운로드할 수 없습니다.'
										)
									}
								})
								.catch(err => {
									console.error('다운로드 중 오류 발생:', err)
									message.error(
										'파일 다운로드 중 오류가 발생했습니다.'
									)
								})
						}}
						type="primary"
						danger
						icon={<IconInfoSquare />}>
						{' '}
						엑셀다운로드
					</Button>
				</Space>
			</View>

			<TableAPI
				title={title}
				columns={AdminDepositTableColumn}
				usermodal={true}
				height={'default'}
				footer={3}
				width={1400}
				apikey={`/admin/user/cash?search=${search}&group=${group}&dtype=${DTYPE}&type=D${makeurl(
					startDate,
					'startdate'
				)}${makeurl(endDate, 'enddate')}${makeurl(
					user_id,
					'userid'
				)}${makeurl(status, 'process')}&t=`}
			/>
		</View>
	)
}

export default React.memo(AdminDepositManagement)
